import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MainNavbar.css';
import roLogo from '../assets/ro logo.png';

const MainNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    
    // Toggle the no-scroll class on the body
    if (newIsOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  };

  const closeMenu = () => {
    setIsOpen(false);
    document.body.classList.remove('no-scroll');
  };

  // Close menu when route changes
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Handle hash link scrolling
  const scrollToSection = (sectionId) => {
    closeMenu();
    
    if (location.pathname !== '/') {
      // If not on home page, navigate to home page with hash and preserve ref
      window.location.href = `/#${sectionId}${location.search}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      // Account for navbar height when scrolling
      const navbarHeight = 70; // Same as var(--navbar-height)
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Cleanup the no-scroll class when component unmounts
  useEffect(() => {
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  // Check if we should hide the navbar - moved after all hooks
  const shouldHideNavbar = location.pathname === '/formular230' && new URLSearchParams(location.search).has('ref');

  // If we should hide the navbar, don't render anything
  if (shouldHideNavbar) {
    return null;
  }

  return (
    <nav className={`main-navbar ${isOpen ? 'menu-open' : ''}`}>
      <div className="main-navbar-container">
        <Link to={`/${location.search}`} className="main-navbar-logo">
          <img src={roLogo} alt="Romania Logo" className="main-navbar-logo-img" />
        </Link>

        <div className="main-navbar-toggle" onClick={toggleMenu}>
          <span className={`main-navbar-icon ${isOpen ? 'open' : ''}`}></span>
        </div>

        <ul className={`main-navbar-menu ${isOpen ? 'active' : ''}`}>
          <li className="main-navbar-item">
            <Link 
              to={`/#info${location.search}`} 
              className="main-navbar-link"
              onClick={() => scrollToSection('info')}
            >
              Info
            </Link>
          </li>
          <li className="main-navbar-item">
            <Link 
              to={`/#premii${location.search}`}
              onClick={() => scrollToSection('premii')}
              className="main-navbar-link"
            >
              Premii
            </Link>
          </li>
          <li className="main-navbar-item">
            <Link 
              to={`/#faq${location.search}`} 
              className="main-navbar-link"
              onClick={() => scrollToSection('faq')}
            >
              FAQ
            </Link>
          </li>
          <li className="main-navbar-item main-navbar-button green mobile-only">
            <a 
              href={process.env.REACT_APP_AUTH_URL} 
              target="_blank" 
              rel="noopener noreferrer"
              className="main-navbar-link"
            >
              Inviți prieteni? Câștigă Garantat 🎉
            </a>
          </li>
          <li className="main-navbar-item main-navbar-button primary mobile-only">
            <Link 
              to={`/formular230${location.search}`} 
              className="main-navbar-link"
            >
              Ești angajat? Completează formularul
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default MainNavbar; 